import { Head, Link, usePage } from '@inertiajs/react';
import { useState, useEffect } from 'react';
import DeleteProductButton from '../../components/DeleteProductButton';
import FlashMessages from '../../components/FlashMessages';
import useCart from '../../store/cart';

export default function Show({ product }) {
  const { current_user } = usePage().props;
  const isAuthenticated = current_user !== null;

  const [activeImage, setActiveImage] = useState(null);
  const [added, setAdded] = useState(false);

  const addItem = useCart((state) => state.addItem);

  useEffect(() => {
    if (product?.image_urls && product.image_urls.length > 0) {
      setActiveImage(product.image_urls[0]);
    }
  }, [product]);

  const handleAddToCart = () => {
    addItem({
      id: product.id,
      name: product.name,
      price: product.price,
      image: activeImage?.url || product.image_urls[0]?.url,
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <>
      <Head title={product.name} />

      <section className='container mx-auto p-4 md:p-8 font-sans'>
        <FlashMessages />

        <div className='grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mt-4'>
          {/* === LEFT COLUMN: IMAGES === */}
          <div className='flex flex-col gap-4'>
            <div className='w-full h-80 md:h-96 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden'>
              {activeImage && (
                <img
                  src={activeImage.url}
                  alt={activeImage.filename || product.name}
                  className='w-full h-full object-contain'
                />
              )}
            </div>

            <div className='flex items-center gap-3'>
              {product.image_urls?.map((image) => (
                <button
                  key={image.id}
                  onClick={() => setActiveImage(image)}
                  className={`w-16 h-16 rounded-md overflow-hidden border-2 transition-all ${
                    activeImage?.id === image.id
                      ? 'border-yellow-secondary'
                      : 'border-transparent'
                  }`}
                >
                  <img
                    src={image.url}
                    alt={image.filename}
                    className='w-full h-full object-cover'
                  />
                </button>
              ))}
            </div>
          </div>

          {/* === RIGHT COLUMN: PRODUCT DETAILS === */}
          <div className='flex flex-col gap-4'>
            <h1 className='text-2xl md:text-3xl font-bold text-yellow-primary'>
              {product.name}
            </h1>

            <div className='flex items-center gap-3 flex-wrap'>
              <p className='text-3xl font-bold text-gray-200'>
                GHS {product.price}
              </p>
            </div>

            <div className='flex items-center gap-3 flex-wrap'>
              <p className='text-sm font-bold text-gray-200'>
                Quantity: {product.quantity}
              </p>
              <p
                className={`text-sm font-semibold ${
                  product.quantity > 0 ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {product.quantity > 0 ? 'In stock' : 'Out of stock'}
              </p>
            </div>

            <hr className='my-4' />

            {/* === ACTION BUTTONS === */}
            <div className='flex flex-col sm:flex-row items-center gap-3'>
              <Link
                href='/products'
                className='w-full text-center rounded-lg py-3 px-5 bg-gray-200 text-gray-800 font-medium hover:bg-gray-300 transition-colors'
              >
                ← Back
              </Link>

              {/* Guest Add to Cart */}
              {!isAuthenticated && (
                <button
                  onClick={handleAddToCart}
                  disabled={product.quantity === 0}
                  className={`w-full text-center rounded-lg py-3 px-5 ${
                    product.quantity > 0
                      ? 'bg-yellow-primary hover:bg-yellow-secondary'
                      : 'bg-gray-400 cursor-not-allowed'
                  } text-gray-800 font-medium transition-colors`}
                >
                  {added ? 'Added!' : 'Add to Cart'}
                </button>
              )}

              {/* Admin Buttons */}
              {isAuthenticated && (
                <>
                  <Link
                    href={`/dashboard/products/${product.id}/edit`}
                    className='w-full text-center rounded-lg py-3 px-5 bg-gray-200 text-gray-800 font-medium hover:bg-gray-300 transition-colors'
                  >
                    Edit
                  </Link>
                  <div className='w-full'>
                    <DeleteProductButton product={product} />
                  </div>
                </>
              )}
            </div>

            <hr className='my-4' />

            <div>
              <h2 className='text-lg font-semibold text-yellow-secondary mb-2'>
                DESCRIPTION
              </h2>
              <div className='bg-orange-50 border border-orange-200 rounded-lg p-4 text-gray-700'>
                <p className='whitespace-pre-line'>🚚 {product.description}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
